import { render, staticRenderFns } from "./strictProduct.vue?vue&type=template&id=5e73393a&scoped=true"
import script from "./strictProduct.vue?vue&type=script&lang=js"
export * from "./strictProduct.vue?vue&type=script&lang=js"
import style0 from "./strictProduct.vue?vue&type=style&index=0&id=5e73393a&prod&lang=scss"
import style1 from "./strictProduct.vue?vue&type=style&index=1&id=5e73393a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e73393a",
  null
  
)

export default component.exports